import React from 'react'
import './ImageSlider.scss'
import 'pure-react-carousel/dist/react-carousel.es.css';


class ImageSlider extends React.Component {
    render() {
        return(
          <div >
            <div id="carouselExampleControls" class="carousel slide" data-ride="carousel">
                <div class="carousel-inner">
                  <div class="carousel-item active">
                    <img class="d-block " height="700" src="/Hd1.png" alt="First slide" />
                  </div>
                  <div class="carousel-item">
                    <img class="d-block" height="700"src="/Hd2.png" alt="Second slide" />
                  </div>
                  <div class="carousel-item">
                    <img class="d-block" height="700" src="/Hd3.png" alt="Third slide" />
                  </div>
                </div>
                <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
                  <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                  <span class="sr-only">Previous</span>
                </a>
                <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
                  <span class="carousel-control-next-icon" aria-hidden="true"></span>
                  <span class="sr-only">Next</span>
                </a>
              </div>
          </div>
        )
    }
}

export default ImageSlider
